var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.4166C22.504 12.9565 22.1442 14.4755 21.45 15.85C20.6268 17.497 19.3614 18.8823 17.7954 19.8508C16.2293 20.8193 14.4246 21.3326 12.5833 21.3333C11.0435 21.3373 9.52447 20.9776 8.15 20.2833L1.5 22.5L3.71667 15.85C3.02242 14.4755 2.66265 12.9565 2.66667 11.4166C2.66738 9.57536 3.18071 7.77063 4.14917 6.20461C5.11763 4.6386 6.50296 3.37313 8.15 2.54997C9.52447 1.85573 11.0435 1.49596 12.5833 1.49997H13.1667C15.5984 1.63413 17.8952 2.66053 19.6173 4.38264C21.3394 6.10476 22.3658 8.40157 22.5 10.8333V11.4166Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatting);
export default __webpack_public_path__ + "static/media/Chatting.d315729562999202e1555f5746cc2ea8.svg";
export { ForwardRef as ReactComponent };